module.exports = __webpack_public_path__ + "static/media/plantEight.591c2557.jpg";